import { getStoredUser } from "../lib/api";

/**
 * useIsAgent gibt true zurueck wenn der eingeloggte User Agent-Modus nutzen
 * kann. Admin zaehlt mit, weil Backend ihn automatisch als Pseudo-Agent
 * impersoniert (siehe deps.current_agent). Daher Admin sieht alle Agent-
 * Pages mit vollwertigen Daten — kein Preview-Banner mehr noetig.
 */
export function useIsAgent(): boolean {
  const role = getStoredUser()?.role;
  return role === "agent" || role === "admin";
}

/**
 * Deprecated: Preview-Banner braucht's nicht mehr — Admin wird vollwertig
 * als Pseudo-Agent eingeloggt. Komponente bleibt fuer Backwards-Compat
 * leer (alle Imports funktionieren weiter, rendert aber nichts).
 */
export function AdminPreviewBanner(_props: { pageName: string }): null {
  return null;
}
